import React, { Component, useEffect, useState } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Alert from '@material-ui/lab/Alert'

import { connect } from 'react-redux'
import { postEnrollmentsData, getSISStatus } from '../../actions'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import Button from '@material-ui/core/Button'

import { getSISImportStatus } from '../../services/saga'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200
  }
}))

let enrollmentCSV = []

const EnrollmentsProcess = (props) => {
  const { data, postEnrollmentsData, enrollmentData } = props

  console.log(enrollmentData)

  const [progress, setProgress] = useState(10)
  const [sisImportID, setSisImportID] = useState(0)
  const [scvErrors, setCsvErrors] = useState([])
  const [errorAttachment, setErrorAttachment] = useState('')

  const [textStatus, setTextStatus] = useState('Processing,Please wait..')

  const [importedItemCounts, setImportedItemCounts] = useState(0)

  const enrollmentCSV = []

  const completed = ''

  useEffect(() => {
    let headers = [
      'user_id',
      'integration_id',
      'login_id',
      'first_name',
      'last_name',
      'sortable_name',
      'short_name',
      'email',
      'status'
    ]

    let csv = [headers, ...data.csvData]

    postEnrollmentsData(csv)
  }, [])

  useEffect(() => {
    const interval = setInterval(async () => {
      if (enrollmentData.sis_status.id && progress !== 100 && progress !== 0) {
        const sisStatus = await getSISImportStatus(
          enrollmentData.sis_status.id,
          ' Create Users'
        )

        let textStatus = ''
        let completed = 0

        if (sisStatus.workflow_state == 'created') {
          textStatus = 'The request has been created.'
          completed = 40
        }

        if (sisStatus.workflow_state == 'importing') {
          textStatus = 'The request is currently processing.'
          completed = 70
        }

        if (sisStatus.workflow_state == 'imported') {
          textStatus = 'The request has completed successfully.'
          completed = 100

          setImportedItemCounts(sisStatus.data.counts)
        }

        if (sisStatus.workflow_state == 'imported_with_messages') {
          textStatus = 'CSV error'
          completed = 0

          setCsvErrors(sisStatus.processing_warnings)

          setErrorAttachment(sisStatus.errors_attachment.url)
        }

        if (sisStatus.workflow_state == 'failed_with_messages') {
          textStatus = 'CSV error'
          completed = 0

          setCsvErrors(sisStatus.processing_errors[0])

          setErrorAttachment(sisStatus?.errors_attachment?.url)
        }

        setProgress(completed)
        setTextStatus(textStatus)
      }
    }, 2000)
    return () => clearInterval(interval)
  }, [enrollmentData.sis_status, sisImportID, progress])

  return (
    <React.Fragment>
      <Typography variant='subtitle1'>{textStatus}</Typography>

      <LinearProgress variant='determinate' value={progress} />

      {progress == 100 ? (
        <ul>
          <li>
            Imported Items
            <ul>
              <li>Users: {importedItemCounts['users']}</li>
            </ul>
          </li>
        </ul>
      ) : null}

      {progress == 100 ? (
        <div>
          {' '}
          <Button
            style={{
              marginTop: '30px',
              marginBottom: '30px'
            }}
            variant='outlined'
            size='large'
            color='primary'
            onClick={() => window.location.reload(false)}
          >
            Back to Home
          </Button>{' '}
        </div>
      ) : (
        ''
      )}

      {errorAttachment !== '' ? (
        <>
          <Alert severity='error'>
            {scvErrors.join(' - ')}

            <a href={errorAttachment} target='_blank'>
              {' '}
              Download Error Attachment{' '}
            </a>
          </Alert>

          <Button
            style={{
              marginTop: '30px',
              marginBottom: '30px'
            }}
            variant='outlined'
            size='large'
            color='primary'
            onClick={() => window.location.reload(false)}
          >
            Back to Home
          </Button>
        </>
      ) : null}
    </React.Fragment>
  )
}

function mapStateToProps(state) {
  return {
    data: state.CreateUsers,

    enrollmentData: state.CourseLevelAdmin
  }
}

export default connect(mapStateToProps, { postEnrollmentsData, getSISStatus })(
  EnrollmentsProcess
)
